import { render, staticRenderFns } from "./CMSGlobalSettingList.vue?vue&type=template&id=12408552&"
import script from "./CMSGlobalSettingList.vue?vue&type=script&lang=js&"
export * from "./CMSGlobalSettingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports